export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEJRVRISy1CNS1IYQihXQGBAgIBgQYCAYEKAgGBDgIBgRICAYEWAgGBGgIBgR5hBKFLAOpODgDrLwEA6zGBBgDqT2EBxuQB7hE=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/ETHK-B5-V.bcmap
// module id = 649
// module chunks = 3